import React from "react";
import styles from "../styles/ExampleUploadConfirmationModal.module.css";

const ExampleUploadConfirmationModal = ({ isOpen, onClose, onConfirm, fileName }) => {
    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modal}>
                <h2 className={styles.modalTitle}>Upload Example File</h2>
                <p className={styles.modalText}>
                    You are about to upload <strong>{fileName}</strong> as an example file.
                </p>
                <p className={styles.modalWarning}>
                    Warning: If an example file already exists for this workflow, it will be permanently replaced with this new file.
                </p>
                <div className={styles.modalActions}>
                    <button className={styles.cancelButton} onClick={onClose}>
                        Cancel
                    </button>
                    <button className={styles.confirmButton} onClick={onConfirm}>
                        Upload Example
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ExampleUploadConfirmationModal;